import { Paper } from "@mantine/core";
import ManageMerchant from "../components/ManageMerchant/ManageMerchant";
import { Headers } from "../components/ui/heading";

function ManageMerchants() {
  return (
    <div className="min-h-screen flex flex-col pb-16">
      <Paper shadow="xs" p="xl">
        <div className="mb-4 flex-shrink-0">
          <Headers name="Manage Merchants" />
        </div>
        <div className="flex-1">
          <ManageMerchant />
        </div>
      </Paper>
    </div>
  );
}

export default ManageMerchants;
